/**
 * Sorts an array of objects numerically based on a specified key.
 *
 * @template T - The type of objects in the array.
 * @param arrayToSort - The array of objects to sort.
 * @param sortByKey - The key of the object to sort by. The value at this key should be a number.
 * @param orderBy - The order to sort by: 'asc' for ascending, 'desc' for descending. Defaults to 'asc'.
 * @returns A new array sorted numerically by the specified key and order.
 */
export const sortNumeric = <T>(arrayToSort: T[], sortByKey: keyof T, orderBy: 'asc' | 'desc' = 'asc'): T[] => {
  return arrayToSort.sort((a: T, b: T) => {
    const aVal = a[sortByKey] as number
    const bVal = b[sortByKey] as number

    return orderBy === 'asc' ? aVal - bVal : bVal - aVal
  })
}

export default sortNumeric
